import {CoreGraphNodeId} from '../../../../../@polygonjs/polygonjs/src/core/graph/CoreGraph';
import {ref, Ref} from '@vue/composition-api';
import {BaseNodeType} from '../../../../../@polygonjs/polygonjs/src/engine/nodes/_Base';

interface EditorPolyNodeUpdateFormControllerClassOptions {
	node: BaseNodeType;
}

export class EditorPolyNodeUpdateFormControllerClass {
	private static _instance: EditorPolyNodeUpdateFormControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorPolyNodeUpdateFormControllerClass());
	}

	private _nodeId!: Ref<CoreGraphNodeId | null>;
	private constructor() {}

	init() {
		this._nodeId = ref(null);
	}

	nodeId() {
		return this._nodeId.value;
	}

	//
	// methods
	//
	async show(options: EditorPolyNodeUpdateFormControllerClassOptions) {
		this._nodeId.value = options.node.graphNodeId();
	}
	close() {
		this._nodeId.value = null;
	}
}

export const EditorPolyNodeUpdateFormController = EditorPolyNodeUpdateFormControllerClass.instance();
